import { z } from 'zod';
import { option, record } from 'fp-ts';
import { flow } from 'fp-ts/function';
import { requiredStringSchema } from './strings';

export const requiredLocalizedFieldSchema = (defaultLanguageCode: string, { max }: { max?: number } = {}) =>
    z
        .object({ [defaultLanguageCode]: max ? requiredStringSchema.max(max) : requiredStringSchema })
        .passthrough()
        .transform(record.filterMap(option.fromNullable));

export const optionalLocalizedFieldSchema = ({ max }: { max?: number } = {}) =>
    z
        .record((max ? z.string().max(max) : z.string()).nullish())
        .nullish()
        .transform(
            flow(
                option.fromNullable,
                option.map(record.filterMap(option.fromNullable)),
                option.getOrElseW(() => ({}))
            )
        );
